import { useEffect } from 'react';

import type { IFrameMessageTypes } from './constants';
import { listenForMessages, type OnMessage } from './utils';

export const useListenForIFrameMessages = (
  messageType: IFrameMessageTypes,
  onMessage: OnMessage
) => {
  useEffect(() => {
    return listenForMessages({
      onMessage,
      types: [messageType],
    });
  }, [messageType, onMessage]);
};
